import {action, computed, decorate, flow, observable} from 'mobx';
import {createSeedUrl, updateSeedUrl,klicountry, selectedLooseLeafUrl} from './APIEndpoints';
import moment from 'moment';
import {DB_DATE_FORMAT, isBlank} from './Util'
import {appStore} from './AppStore';
import looseLeafListStore from './LooseLeafListStore';
import {message} from "antd";

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const HEADSUP_TO_IFP = 64;
const HEADSUP_TO_FTA = 18;

const IFP_DATE_SHOULD_BE_AFTER_TODAY = "The IFP Date should be a future date";
const HEADS_UP_SHOULD_BE_AFTER_TODAY = "The Heads-up Email Date should be a future date";
const FTA_SHOULD_BE_AFTER_TODAY = "The Files to Author Date should be a future date";
const FFA_SHOULD_BE_AFTER_TODAY = "The Files from Author Date should be a future date";
const BLANK_DATE_FIELDS = "Please provide vaild data for required fields";
const HEADS_UP_SHOULD_BE_BEFORE_IFP = "The Heads-up Email Date should be before IFP Date";
const FTA_DATE_SHOULD_BE_BEFORE_IFP = "The Files to Author Date should be before IFP Date";
const FFA_DATE_SHOULD_BE_BEFORE_IFP = "The Files From Author Date should be before IFP Date";
const FTA_SHOULD_BE_BEFORE_FFA = "The Files to Author Date should be before File from Author Date";


class LooseLeafStore {
    @observable activeTab = '0';
    @observable looseLeafSeed = {};
    @observable drawerVisible = false;
    @observable formLoading = false;
    @observable updatedate = false;
    @observable rowclick = false;
    @observable getCountrylist = [];
    @observable getCountryName = '';
    @observable selectedMenu = '';
    @observable projectId = '';
    // @observable getCountry = this.setCountry();
    @observable schedulefieldDefs = [
        {
            key: "recyclePeriod",
            label: "Recycle Period",
            type: "number",
            defaultValue: '',
            required: true,
            disabled: false,
            onChange:this.saveScheduleUpdate
        },
        {
            key: "projectStartDate",
            label: "Request Date",
            type: "date",
            defaultValue: '',
            required: true,
            disabled: false,
            onChange:this.saveScheduleUpdate
        },
        {
            key: "filesToAuthorDate",
            label: "Send files to author on",
            type: "date",
            defaultValue: '',
            required: true,
            disabled: false,
            onChange:this.saveScheduleUpdate
        },
        {
            key: "filesFromAuthorDate",
            label: "Expect files from author on",
            type: "date",
            defaultValue: '',
            required: true,
            disabled: false,
            onChange:this.saveScheduleUpdate
        },
        {
            key: "ifpDate",
            label: "IFP Date",
            type: "date",
            defaultValue: '',
            required: false,
            disabled: false,
           
        },
        {
            key: "cmpDate",
            label: "CMP Date",
            type: "date",
            defaultValue: '',
            required: false,
            disabled: false,
           
        }
    ]
   @action saveScheduleUpdate=()=>{
    
    }

    @action setDrawerVisible = visible => {
        this.drawerVisible = visible;
    };

    @action setFormLoading = loading => {
        this.formLoading = loading;
    };

    get apiProxy() {
        return appStore.apiProxy;
    }
    

    @action createNewSeed = async (data) => {
        
        if (this.looseLeafSeed.id) {
            await this.updateInfo(data);
        }
        else
        {
            data.country = this.getCountryName;
            data.createdBy = 'CHASER_EMAIL';
            data.projectId = -1;
              
            if(data.titleId == 498 || data.titleId == 496 || data.titleId == 500 || data.titleId == 497)
              {
                data.reseedType = 'BASEDONATASK';
                data.abstractTaskId= 132;
                data.recyclePeriod=181;
              }
            else if(data.titleId == 1408)
              {
                data.reseedType = 'BASEDONATASK';
                data.abstractTaskId= 132;
                data.recyclePeriod=2;
              }
            else if(data.titleId == 1293)
              {
                data.reseedType = 'BASEDONTHELASTUPDATEDATE';
                data.abstractTaskId= 132;
                data.recyclePeriod=262;
              }
            else if(data.titleId == 493)
              {
                data.reseedType = 'FIXED';
                data.reseedFixedDates= 'YYYY-02-01';
              }
          
            console.log(data);
            const seed = await this.makeApiCall(this.apiProxy.asyncPost(createSeedUrl, data));
            this.looseLeafSeed = seed;
            if (this.looseLeafSeed.id) {
                looseLeafListStore.fetchAwaiting();
                looseLeafListStore.fetchPlanned();
            }
        }
       
       
    };
    @action updateLooseLeafSeedDefaultInfo = async()=>{
        if(this.looseLeafSeed.reseedType != '')
        {
          if(this.looseLeafSeed.abbreviation == 'IEADA' || this.looseLeafSeed.abbreviation == 'ENF' || this.looseLeafSeed.abbreviation == 'MLH' || this.looseLeafSeed.abbreviation == 'EICLIT')
          {
            this.looseLeafSeed.reseedType = 'BASEDONATASK';
            this.looseLeafSeed.abstractTaskId= 132;
            this.looseLeafSeed.recyclePeriod=181;
          }
          else if(this.looseLeafSeed.abbreviation == 'NGTEST')
          {
            this.looseLeafSeed.reseedType = 'BASEDONATASK';
            this.looseLeafSeed.abstractTaskId= 132;
            this.looseLeafSeed.recyclePeriod=2;
          }
          else if(this.looseLeafSeed.abbreviation == 'MIP')
          {
            this.looseLeafSeed.reseedType = 'BASEDONTHELASTUPDATEDATE';
            this.looseLeafSeed.abstractTaskId= 132;
            this.looseLeafSeed.recyclePeriod=262;
          }
          else if(this.looseLeafSeed.abbreviation == 'ILEL')
          {
            this.looseLeafSeed.reseedType = 'FIXED';
            this.looseLeafSeed.reseedFixedDates= 'YYYY-02-01';
          }
        }
       
    }
    @action updateInfo = async (data) => {
        data.country = this.getCountryName;
        
        if(data.titleId)
        {
            if(data.titleId == 498 || data.titleId == 496 || data.titleId == 500 || data.titleId == 497)
            {
            data.reseedType = 'BASEDONATASK';
            data.abstractTaskId= 132;
            data.recyclePeriod=181;
            }
            else if(data.titleId == 1408)
            {
            data.reseedType = 'BASEDONATASK';
            data.abstractTaskId= 132;
            data.recyclePeriod=2;
            }
            else if(data.titleId == 1293)
            {
            data.reseedType = 'BASEDONTHELASTUPDATEDATE';
            data.abstractTaskId= 132;
            data.recyclePeriod=262;
            }
            else if(data.titleId == 493)
            {
            data.reseedType = 'FIXED';
            data.reseedFixedDates= 'YYYY-02-01';
            }
       }
        this.looseLeafSeed = {...this.looseLeafSeed, ...data};
        const seed = await this.makeApiCall(this.apiProxy.asyncPost(updateSeedUrl, this.looseLeafSeed));
        this.looseLeafSeed =seed
        if (this.looseLeafSeed.id) {
            if(this.selectedMenu == "awaitingSeeds") ///plannedSeeds activeSeeds
            {
                looseLeafListStore.fetchAwaiting();
            }else if(this.selectedMenu == "plannedSeeds")
            {
                looseLeafListStore.fetchPlanned();
            }else if(this.selectedMenu == "activeSeeds")
            {
                looseLeafListStore.fetchActive();
            }

        }
    
    };
    @action deleteSelectedRow = async (data) => {
        this.looseLeafSeed.deletedBy = appStore.credentials.userId;
        this.looseLeafSeed.deletedAt = new Date().toISOString().slice(0, 19).replace('T', ' ');
        console.log(this.looseLeafSeed);
        const seed = await this.makeApiCall(this.apiProxy.asyncPost(updateSeedUrl, this.looseLeafSeed));
        this.looseLeafSeed = seed;
        if (this.looseLeafSeed.id) {
            if(this.selectedMenu == "awaitingSeeds") ///plannedSeeds activeSeeds
            {
                looseLeafListStore.fetchAwaiting();
            }else if(this.selectedMenu == "plannedSeeds")
            {
                looseLeafListStore.fetchPlanned();
            }else if(this.selectedMenu == "activeSeeds")
            {
                looseLeafListStore.fetchActive();
            }

        }
    }

    @action savePeopleInfo = async (data) => {
        this.looseLeafSeed = {...this.looseLeafSeed, ...data};
       
        const seed = await this.makeApiCall(this.apiProxy.asyncPost(updateSeedUrl, this.looseLeafSeed));
      
        this.looseLeafSeed = seed;
    
        if (this.looseLeafSeed.id) {
          
                if(this.selectedMenu == "awaitingSeeds") ///plannedSeeds activeSeeds
                {
                    looseLeafListStore.fetchAwaiting();
                }else if(this.selectedMenu == "plannedSeeds")
                {
                    looseLeafListStore.fetchPlanned();
                }else if(this.selectedMenu == "activeSeeds")
                {
                    looseLeafListStore.fetchActive();
                }
    
            
            return false;
        }
    };

    @action saveScheduleInfo = async (data) => {
        this.looseLeafSeed = {...this.looseLeafSeed, ...data};
        this.looseLeafSeed.projectId = -1; // marks seed as ready for creation
        const seed = await this.makeApiCall(this.apiProxy.asyncPost(updateSeedUrl, this.looseLeafSeed));
        this.looseLeafSeed = seed;
        if (this.looseLeafSeed.id) {
          
                if(this.selectedMenu == "awaitingSeeds") ///plannedSeeds activeSeeds
                {
                    looseLeafListStore.fetchAwaiting();
                }else if(this.selectedMenu == "plannedSeeds")
                {
                    looseLeafListStore.fetchPlanned();
                }else if(this.selectedMenu == "activeSeeds")
                {
                    looseLeafListStore.fetchActive();
                }
    
          
            return false;
        }
    };
    @action saveScheduleUpdate = async (data) => {
        this.looseLeafSeed = {...this.looseLeafSeed, ...data};
        //marks seed as ready for creation
        const seed = await this.makeApiCall(this.apiProxy.asyncPost(updateSeedUrl, this.looseLeafSeed));
        this.looseLeafSeed =seed;
        if (this.looseLeafSeed.id) {
            if(this.selectedMenu == "awaitingSeeds") ///plannedSeeds activeSeeds
                {
                    looseLeafListStore.fetchAwaiting();
                }else if(this.selectedMenu == "plannedSeeds")
                {
                    looseLeafListStore.fetchPlanned();
                }else if(this.selectedMenu == "activeSeeds")
                {
                    looseLeafListStore.fetchActive();
                }
            return false;
        }
    };
    // @action setCountry = async()=>{
    //     let country = await this.apiProxy.getAsync(klicountry);
        
    //     const response = await country.json();
      
    //     // const response1 = await response.map(t => ({
    //     //     label: t.short_title,
    //     //     value: t.short_title
    //     //   }));
    //     //   return response1;
    //     return response;
       
    // }

    makeApiCall = async (promise) => {
        this.formLoading = true;
        try {
            let response = await promise;
            this.nextTab();
            this.formLoading = false;
            return await response.json();
        } catch (e) {
            console.error(e);
            message.error('Something went wrong. Please try later');
            this.formLoading = false;
            return {};
        }
    };

    @action nextTab = () => {
        if (this.activeTab == "0") {
            this.activeTab = "1";
        } else if (this.activeTab == "1") {
            this.activeTab = "2";
        } else {
            this.drawerVisible = false;
            this.activeTab = "0";
        }
    };

    fetchLooseLeaf = flow(function* (seedId, rowIndex, oldData) {
        this.state = PENDING;

        try {
            const url = selectedLooseLeafUrl.replace('{id}', seedId);

            const response = yield this.apiProxy.getAsync(url);
            const data = yield response.json();

            this._setData(data);
            this.rowIndex = rowIndex;
            this.oldData = oldData;

        } catch (e) {
            this.state = ERROR;
        }
    });

    _setData = (data) => {
        this.looseLeafSeed = data;
        this._validateSchedule();
        this.state = DONE;
        this.activeTab = "0";
        this.showDrawer = true;
    };

    get isEditable() {
        return this.state === DONE;
    }

    newSeed = async () => {
        this.looseLeafSeed = {};
        this.rowIndex = 0;
        this.oldData = {};
        this.showDrawer = true;
        this.activeTab = "0";

        this.suggestedFilesFromAuthorDate = null;
        this.suggestedFilesToAuthorDate = null;

        this.isValidSchedule = true;
        this.validationMessage = '';
    };

    save = async (values) => {
        this.state = PENDING;

        try {
            let tabIndex = parseInt(this.activeTab);
            let postUrl = this.drawerTabs[tabIndex].postUrl;
            if (this.looseLeafSeed.id === undefined) {
                postUrl = newSeedUrl;
            }

            if (postUrl != undefined) {
                const response = await this.apiProxy.asyncPost(postUrl, {id: this.looseLeafSeed.id, ...values});
                const data = await response.json();
                this.looseLeafSeed = data;
            }

            this.state = DONE;
            tabIndex = tabIndex < this.drawerTabs.length - 1 ? tabIndex + 1 : tabIndex;
            this.activeTab = tabIndex.toString();
        } catch (e) {
            console.log(e);
            this.state = ERROR;
        }
    };

    saveSchedule = async () => {
        this.state = PENDING;

        try {
            const response = await this.apiProxy.asyncPost(saveScheduleUrl, {...this.looseLeafSeed});
            const data = await response.json();
            this.looseLeafSeed = data;

            this.showDrawer = false;
            looseLeafListStore.updateRowData(this.rowIndex, data, this.oldData);
            this.state = DONE;
        } catch (e) {
            console.log(e);
            this.state = ERROR;
        }
    };

    finalizeSchedule = async (e) => {
        this.state = PENDING;

        try {
            const response = await this.apiProxy.asyncPost(finalizeScheduleUrl, {...this.looseLeafSeed});
            const data = await response.json();
            this.looseLeafSeed = data;

            this.showDrawer = false;
            looseLeafListStore.fetchAwaiting();
            this.state = DONE;
        } catch (e) {
            console.log(e);
            this.state = ERROR;
        }
    };

    reschedule = (fieldName, dateString) => {
        this.looseLeafSeed[fieldName] = dateString;

        if ((fieldName === 'deadlinePeriod' && !isBlank(this.looseLeafSeed.filesToAuthorDate)) || (fieldName === 'filesToAuthorDate' && this.looseLeafSeed.deadlinePeriod !== 0)) {
            const filesToAuthorDate = this.looseLeafSeed.filesToAuthorDate;
            const deadlinePeriod = this.looseLeafSeed.deadlinePeriod;
            const filesFromAuthorDate = moment(filesToAuthorDate, DB_DATE_FORMAT).businessAdd(deadlinePeriod, "days").format(DB_DATE_FORMAT);
            this.suggestedFilesFromAuthorDate = filesFromAuthorDate;
            this.looseLeafSeed.filesFromAuthorDate = filesFromAuthorDate;
        }
        // if (fieldName === 'ifpDate') {
        //     const ifpDate = dateString;

        //     console.log(dateString);
        //     const headsUpEmailDate = moment(ifpDate, DB_DATE_FORMAT).businessSubtract(HEADSUP_TO_IFP, "days").format(DB_DATE_FORMAT);
        //     const filesToAuthorDate = moment(headsUpEmailDate, DB_DATE_FORMAT).businessAdd(HEADSUP_TO_FTA, "days").format(DB_DATE_FORMAT);

        //     this.suggestedHeadsUpEmailDate = headsUpEmailDate;
        //     this.suggestedFilesToAuthorDate = filesToAuthorDate;

        //     this.looseLeafSeed.headsUpEmailDate = headsUpEmailDate;
        //     this.looseLeafSeed.filesToAuthorDate = filesToAuthorDate;
        // }
        // else if (fieldName === 'headsUpEmailDate') {
        //     const headsUpEmailDate = dateString;

        //     const filesToAuthorDate = moment(headsUpEmailDate, DB_DATE_FORMAT).businessAdd(HEADSUP_TO_FTA, "days").format(DB_DATE_FORMAT);

        //     this.suggestedFilesToAuthorDate = filesToAuthorDate;
        //     this.looseLeafSeed.filesToAuthorDate = filesToAuthorDate;
        // }

        this._validateSchedule();
    }

    _validateSchedule = () => {
        if (isBlank(this.looseLeafSeed.filesToAuthorDate) || isBlank(this.looseLeafSeed.filesFromAuthorDate) || this.looseLeafSeed.recyclePeriod === 0 || this.looseLeafSeed.deadlinePeriod === 0) {
            this.validationMessage = BLANK_DATE_FIELDS;
            this.isValidSchedule = false;
            return;
        }

        const today = moment(new Date(), DB_DATE_FORMAT);

        if (moment(this.looseLeafSeed.filesToAuthorDate, DB_DATE_FORMAT).isBefore(today)) {
            this.validationMessage = FTA_SHOULD_BE_AFTER_TODAY;
            this.isValidSchedule = false;
        } else if (moment(this.looseLeafSeed.filesFromAuthorDate, DB_DATE_FORMAT).isBefore(today)) {
            this.validationMessage = FFA_SHOULD_BE_AFTER_TODAY;
            this.isValidSchedule = false;
        } else if (moment(this.looseLeafSeed.filesFromAuthorDate, DB_DATE_FORMAT).isBefore(moment(this.looseLeafSeed.filesToAuthorDate, DB_DATE_FORMAT))) {
            this.validationMessage = FTA_SHOULD_BE_BEFORE_FFA;
            this.isValidSchedule = false;
        } else {
            this.validationMessage = '';
            this.isValidSchedule = true;
        }

    }

}

// decorate(LooseLeafStore, {
//     state: observable,
//     showDrawer: observable,
//     activeTab: observable,
//
//     looseLeafSeed: observable,
//     suggestedFilesToAuthorDate: observable,
//     suggestedFilesFromAuthorDate: observable,
//     isValidSchedule: observable,
//     validationMessage: observable,
//
//     save: action,
//     reschedule: action,
//     saveSchedule: action,
//
//     fieldDefs: computed,
//     isEditable: computed
// });

export default new LooseLeafStore();
